'use client';

import dynamic from 'next/dynamic';
import * as Content from '@components/content';
import { useTranslations } from 'next-intl';

const CardList = dynamic(() => import('./card-list'), {
  ssr: false,
});

function Requirements() {
  const t = useTranslations('Sample.requirements');
  return (
    <Content.Section>
      <Content.Title title={t('title')} />
      <CardList />
    </Content.Section>
  );
}

export default Requirements;
